import Backbone from 'backbone.marionette'
import $ from 'jquery'
import hoverIntent from 'jquery-hoverintent'
import Dropzone from 'dropzone'

class KCVS.Views.ReportFilesView extends Backbone.View
  events:
    "click .file-description" : "editFileComment"
    "ajax:success form.edit_report_file" : "submitDescription"
    "click .close-report-file-form" : "calcelDescriptionEdit"

  initialize: ->
    if $('.dropzone')[0]
      @initDropzone()

    if $('*[data-popload]')[0]
      $('*[data-popload]').hoverIntent @quickFilePreview, @closeFilePreview, timeout: 1000
      $(document).on 'click', @closeFilePreview

  initDropzone: ->
    AUTH_TOKEN = $('meta[name="csrf-token"]').attr('content')
    files_description = $('#report_file_description').val()
    Dropzone.autoDiscover = false

    myDropzone = new Dropzone('.dropzone',
      url: $('form.dropzone').attr('action')
      autoProcessQueue: false
      uploadMultiple: true
      addRemoveLinks: true
      parallelUploads: 50
      previewsContainer: '.dropzone-previews'
      clickable: '.dropzone-previews'
      params: 'authenticity_token': AUTH_TOKEN
      dictDefaultMessage: I18n.t('javascript.dropzone.drop_here')
      dictCancelUpload: I18n.t('cancel')
      dictRemoveFile: I18n.t('delete')

      successmultiple: (data, response) ->
        $('.msgBoard').append(response.message).addClass 'alert alert-success'
        $('.msgBoard').delay(5000).fadeOut()
        $('#fileslist').val response.files_list

        return
    )

    $('form.dropzone').submit (e) ->
      e.preventDefault()
      e.stopPropagation()

      if myDropzone.getQueuedFiles().length > 0
        myDropzone.processQueue()
        myDropzone.on('complete', () =>
          location.reload()
        )
      else
        $('.msgBoard').append('Lūdzu norādiet failus pirms veikt augšupielādi').addClass 'alert alert-success'
        $('.msgBoard').delay(5000).fadeOut()
      return

  quickFilePreview: (e) ->
    e = $(this)
    attr = e.attr('aria-describedby')
    unless (typeof attr != typeof undefined && attr != false)
      if (e.parent().hasClass('pdf') || e.parent().hasClass('png') || e.parent().hasClass('jpg'))
        e.off 'hover'
        $.get e.data('popload'), (d) ->
          e.popover(content: d, html: true, container: e, sanitize: false).popover 'show'
          return

  closeFilePreview: (e) ->
    $('[data-original-title]').popover 'hide'

  editFileComment: (e) ->
    e.preventDefault()
    $this = $(e.target)
    $.get $this.attr("href"), (d) ->
      $this.parent(".file-description-container").html(d)
      return

  submitDescription: (e, data, status, xhr) ->
    $this = $(e.target)
    $this.parent(".file-description-container").html(data)

  calcelDescriptionEdit: (e) ->
    e.preventDefault()
    $this = $(e.currentTarget)
    $this.parents(".file-description-container").html($this.data("html"))
